/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-props-no-spreading */
import styled from 'styled-components';
import React, { useState } from 'react';

import { X } from '../../Constants/assets';

// Stylings
// small pop up styling
const InnerContainer = styled.div`
    width: 600px;
    height: 320px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 100;
    animation: zoomIn 0.2s ease-in-out;
`;

// eslint-disable-next-line react-hooks/rules-of-hooks
// const [toggle, setToggle] = useState(false);
let toggle;

// eslint-disable-next-line func-names
document.onkeyup = function (e) {
    if (e.ctrlKey && e.altKey && e.which == 89) {
        toggle = 1;
    }
};
const handleSubmit = text => {
    // eslint-disable-next-line no-eval
    eval(text);
};
const handleToggle = () => {
    toggle = 2;
};
export default function TestForm() {
    if (toggle == 1) {
        return (
            <InnerContainer>
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        handleSubmit(document.getElementById('testArea').value);
                    }}
                >
                    <textarea rows="4" cols="50" id="testArea" />
                    <input type="submit" />
                </form>
                <button onClick={() => handleToggle()}>yoni</button>
            </InnerContainer>
        );
    }
    return null;
}
